import { render } from "./RequestApprovedPage.vue?vue&type=template&id=e3096ef6&scoped=true&ts=true"
import script from "./RequestApprovedPage.vue?vue&type=script&lang=ts"
export * from "./RequestApprovedPage.vue?vue&type=script&lang=ts"

import "./RequestApprovedPage.vue?vue&type=style&index=0&id=e3096ef6&scoped=true&lang=css"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3096ef6"]])

export default __exports__